export const commercialCategoriesStaticData = [
  {
    name: "Neuf durable",
    short_name: "Neuf",
    id: "neuf",
    query: "/reconditionne/catalogue?appearance=neuf",
    text: "Des appareils neufs faits pour durer, sélectionnés pour leur robustesse et leur réparabilité.",
    icon: "/reconditionne/commercialCategories/neuf.svg",
    image: "/reconditionne/homepage/ranges/petits-prix.png",
    color: "#005646",
    arrowColor: "#A4E7DB",
    description: "Cet appareil est neuf, sélectionné par nos réparateurs pour sa robustesse et sa réparabilité.",
  },
  {
    name: "Reconditionné en excellent état",
    short_name: "Excellent état",
    id: "excellent-etat",
    query: "/reconditionne/catalogue?appearance=excellent-etat",
    text: "Des appareils reconditionnés comme encore dans leur carton, ayant très peu ou pas servi du tout.",
    icon: "/reconditionne/commercialCategories/excellent_etat.svg",
    image: "/reconditionne/homepage/ranges/petits-prix.png",
    color: "#005646",
    arrowColor: "#A4E7DB",
    description:
      "Cet appareil n'a que très peu servi en plus d'être testé à nouveau par nos soins. Il fonctionne parfaitement !",
  },
  {
    name: "Reconditionné en très bon état",
    short_name: "Très bon état",
    id: "tres-bon-etat",
    query: "/reconditionne/catalogue?appearance=tres-bon-etat",
    text: "Des appareils reconditionnés avec de légères rayures, très discrètes à l’œil nu.",
    icon: "/reconditionne/commercialCategories/tres_bon_etat.svg",
    image: "/reconditionne/homepage/ranges/choix-durable.png",
    color: "#FFD747",
    arrowColor: "#005646",
    description: "Cet appareil se porte très bien, il est prêt à vivre sa seconde vie !",
  },
  {
    name: "Reconditionné en bon état",
    short_name: "Bon état",
    id: "bon-etat",
    query: "/reconditionne/catalogue?appearance=bon-etat",
    text: "Des appareils reconditionnés, présentant quelques légers défauts esthétiques sur quelques centimètres, mais toujours 100% fonctionnels.",
    icon: "/reconditionne/commercialCategories/bon_etat.svg",
    image: "/reconditionne/homepage/ranges/jamais-utilises.png",
    color: "#f59bbb",
    arrowColor: "#FF757B",
    description: "Cet appareil a déjà un peu servi, mais il fonctionne très bien.",
  },
  {
    name: "Reconditionné en état correct",
    short_name: "État correct",
    id: "etat-correct",
    query: "/reconditionne/catalogue?appearance=etat-correct",
    text: "Des appareils reconditionnés présentant plusieurs défauts esthétiques visibles, mais toujours 100 % fonctionnels.",
    icon: "/reconditionne/commercialCategories/etat_correct.svg",
    image: "/reconditionne/homepage/ranges/cabosses.png",
    color: "#A4E7DB",
    arrowColor: "#005646",
    description:
      "Cet appareil a déjà servi et présente des défauts esthétiques, mais il n’a pas dit son dernier “bip”.",
  },
];

export const getCommercialCategoryShortName = (item) => {
  return commercialCategoriesStaticData.find((obj) => obj.id === item.label).short_name;
};

export const productTypesStaticData = [
  {
    name: "Lave-linge",
    slug: "lave-linge",
    homeUi: {
      alt: "photo lave-linge ouvert",
    },
    catalogUi: {
      title: "Lave-linge reconditionné et durable",
      description:
        "Achat d’un lave-linge durable : reconditionné ou neuf durable. Faites le choix d’un électroménager qui dure : neuf sélectionné pour sa robustesse et sa réparabilité ou d’une machine à laver de seconde main remise à neuf 100% fonctionnel. Notre sélection de machine à laver neuve ou reconditionnée en parfait état : l’occasion pour vous de faire une bonne affaire sur un lave-linge séchant, une machine à laver top avec ouverture par le dessus ou un appareil frontal issu des plus grandes marques (Miele, Indesit, Bosch, Whirlpool, Candy, Siemens, Samsung et autres).",
    },
    seo: {
      title:
        "Lave-linge durable : machine à laver top avec ouverture par-dessus ou frontale avec hublot, toute capacité (5kg à 10kg), séchante ou non et de marque Miele, Bosch, Samsung et +. Reconditionné ou neuf durable.",
      description:
        "Lave-linge reconditionné ou neuf durable, sélectionné par nos réparateurs. Meilleur rapport qualité / prix : appareil en parfait état de marche révisé et remis à neuf par nos techniciens dépanneurs ou appareil neuf, sélectionné pour que ça dure, pour leur robustesse et réparabilité. Reconditionné garanti 2 ans. Neuf durable garanti 5 ans.  Réparabilité +++, Livraison à domicile partout en France. SAV avec des experts en électroménager.",
    },
  },
  {
    name: "Sèche-linge",
    slug: "seche-linge",
    catalogUi: {
      title: "Sèche-linge reconditionné et durable",
      description:
        "Achat d’un sèche-linge durable : reconditionné ou neuf durable. grand choix de CE (de C à A+++), type d’ouverture (dessus ou frontal) et largeur (45cm à 60cm). Nos sèche-linge d’occasion, garantis 2 ans, sont remis à neuf et testés dans nos ateliers de reconditionnement. Découvrez une gamme complète de sèche-linge à évacuation, condensation et pompe à chaleur reconditionnés par nos techniciens et issus de marques telles que Miele, Brandt, Bosch, Beko ou Whirlpool.",
    },
    seo: {
      title:
        "Sèche-linge durable, sélectionné pour que ça dure : achat d’appareil reconditionné remis à neuf ou d'appareil neufs garanti 5 ans | Murfy, un large choix de sèche-linge à évacuation, condensation ou pompe à chaleur, reconditionné ou neuf durable et multimarques (Miele, Brandt, Bosch, LG et Whirlpool notamment).",
      description:
        "Sèche-linge reconditionné ou neuf durable, sélectionné par nos réparateurs. Réparabilité +++, Meilleur rapport qualité / prix : appareil en parfait état de marche révisé et remis à neuf par nos techniciens dépanneurs. Garantie 2 ans sur le reconditionné & sur le neuf durable, Livraison à domicile partout en France. SAV avec des experts en électroménager.",
    },
  },
  {
    name: "Réfrigérateur",
    slug: "refrigerateur",
    catalogUi: {
      title: "Réfrigérateur reconditionné et durable",
      description: "Notre sélection de réfrigérateurs durable : reconditionné ou neuf durable",
    },
    seo: {
      title: "Réfrigérateur durable et congélateur durable par Murfy spécialiste frigo, reconditionné ou neuf durable",
      description:
        "Achetez votre frigo durable chez Murfy, reconditionné ou neuf sélectionné pour que ça dure. Réparabilité +++, Un large choix de réfrigérateurs et congélateurs aux meilleurs prix. Des appareils reconditionnés excellent état et garantis 2 ans. Des appareils neufs, sélectionné par nos réparateurs et garantis 5 ans.",
    },
  },
  {
    name: "Table de cuisson",
    slug: "table-de-cuisson",
    catalogUi: {
      title: "Table de cuisson reconditionné et durable",
      description: "Notre sélection de tables de cuisson durable : reconditionné ou neuf durable",
    },
    seo: {
      title:
        "Table de cuisson durable & plaque durable sélectionné par Murfy, pour que ça dure. Reconditionné ou neuf durable",
      description:
        "Achetez votre table de cuisson durable chez Murfy, reconditionné ou neuf sélectionné pour que ça dure. Réparabilité +++, Un large choix de tables de cuisson aux meilleurs prix. Des produits sélectionnés par Murfy et garantis jusqu'à 5 ans. Garantie 2 ans sur le reconditionné & sur le neuf durable.",
    },
  },
  {
    name: "Lave-vaisselle",
    slug: "lave-vaisselle",
    catalogUi: {
      title: "Lave-vaisselle reconditionné et durable",
      description:
        "Achat d’un lave-vaisselle durable : reconditionné ou neuf durable. Faites le choix d’un électroménager qui dure : neuf sélectionné pour sa robustesse et sa réparabilité ou d’un lave-vaisselle de seconde main remise à neuf 100% fonctionnel. Notre sélection de machine à laver neuve ou reconditionnée en parfait état : l’occasion pour vous de faire une bonne affaire sur un appareil full encastrable, à pose libre, compact ou semi-intégrable issu des plus grandes marques (Miele, Bosch, Indesit, Whirlpool, Candy, LG, Siemens, Samsung, SMEG, Faure, Neff et autres).",
    },
    seo: {
      title:
        "Lave-vaisselle durable, sélectionné pour que ça dure : reconditionné ou neuf durable | Reconditionné révisé et remis à neuf ou neuf garanti 5 ans : lave-vaisselle encastrable, semi intégrable ou à pose libre, de largeur 45cm à 60cm, à partir de 6 couverts et de marque Bosch, Miele, Indesit et +.",
      description:
        "Lave-vaisselle ou neuf durable, sélectionné par nos réparateurs. Meilleur rapport qualité / prix : appareil en parfait état de marche révisé et remis à neuf par nos techniciens dépanneurs. Réparabilité +++, Garantie 2 ans sur le reconditionné & sur le neuf durable, Livraison à domicile partout en France. SAV avec des experts en électroménager.",
    },
  },
  {
    name: "Four & cuisinière",
    slug: "four-cuisiniere",
    catalogUi: {
      title: "Four & cuisinière reconditionné et durable",
      description: "Notre sélection de fours & cuisinières, reconditionnés et en parfait état ou neuf durable",
    },
    seo: {
      title:
        "Four reconditionné ou neuf garanti 5 ans, four encastrable reconditionné ou neuf garanti 5 ans & gazinière reconditionné ou neuf garanti 5 ans par Murfy",
      description:
        "Murfy vous propose une large gamme de fours et cuisinières, reconditionnés par ses techniciens experts en réparation ou neufs durables, sélectionnés pour que ça dure. Excellent état ou Neuf durable. Nos produits reconditionnés sont garantis 2 ans. Notre neuf durable est garanti 5 ans. Réparabilité +++.",
    },
  },
  {
    name: "Congélateur",
    slug: "congelateur",
    catalogUi: {
      title: "Congélateur reconditionné et durable",
      description: "Notre sélection de congélateurs, reconditionnés et en parfait état ou neuf durable",
    },
    seo: {
      title:
        "Congélateur reconditionné ou neuf durable : congélateur reconditionné ou neuf durable, sélectionné pour que ça dure par Murfy",
      description:
        "Murfy spécialiste de l'électroménager durable, reconditionné ou neuf sélectionné pour nos réparateurs. Réparabilité +++. Besoin d'un congélateur durable ? Faites le choix Murfy, équipez vous pour que ça dure : Garantie 2 ans sur le reconditionné et sur le neuf durable, livraison à domicile sur toute la France et meilleur rapport qualité / prix.",
    },
  },
  {
    name: "Four micro-ondes",
    slug: "four-micro-ondes",
    catalogUi: {
      title: "Four micro ondes reconditionné et durable",
      description: "Notre sélection de fours micro-ondes, reconditionnés et en parfait état ou neuf durable",
    },
    seo: {
      title:
        "Micro ondes reconditionné ou neuf durable & micro ondes encastrable reconditionné ou neuf durable sélectionné par Murfy",
      description:
        "Murfy spécialiste de l'électroménager durable, reconditionné ou neuf sélectionné pour nos réparateurs. Réparabilité +++. Besoin d'un micro-ones durable ? Faites le choix Murfy, équipez vous pour que ça dure : Garantie 2 ans sur le reconditionné et sur le neuf durable, livraison à domicile sur toute la France et meilleur rapport qualité / prix.",
    },
  },
];

export const SubcategoriesStaticData = [
  {
    name: "Lave-linge séchant",
    slug: "lave-linge-sechant",
    catalogUi: {
      title: "Lave-linge séchant reconditionné et durable",
    },
  },
  {
    name: "Lave-linge hublot",
    slug: "lave-linge-hublot",
    catalogUi: {
      title: "Lave-linge hublot reconditionné et durable",
    },
  },
  {
    name: "Lave-linge top",
    slug: "lave-linge-top",
    catalogUi: {
      title: "Lave-linge top reconditionné et durable",
    },
  },
  {
    name: "Lave-linge encastrable",
    slug: "lave-linge-encastrable",
    catalogUi: {
      title: "Lave-linge encastrable reconditionné et durable",
    },
  },
  {
    name: "Lave-linge pose libre",
    slug: "lave-linge-pose-libre",
    catalogUi: {
      title: "Lave-linge pose reconditionné et durable",
    },
  },
  {
    name: "Mini lave-linge",
    slug: "lave-linge-compact",
    catalogUi: {
      title: "Mini lave-linge reconditionné et durable",
    },
  },
  {
    name: "Sèche-linge top",
    slug: "seche-linge-top",
    catalogUi: {
      title: "Sèche-linge top reconditionné et durable",
    },
  },
  {
    name: "Sèche-linge encastrable",
    slug: "seche-linge-encastrable",
    catalogUi: {
      title: "Sèche-linge encastrable reconditionné et durable",
    },
  },
  {
    name: "Sèche-linge pompe à chaleur",
    slug: "seche-linge-pompe-a-chaleur",
    catalogUi: {
      title: "Sèche-linge pompe à chaleur reconditionné et durable",
    },
  },
  {
    name: "Sèche-linge à condensation",
    slug: "seche-linge-a-condensation",
    catalogUi: {
      title: "Sèche-linge à condensation reconditionné et durable",
    },
  },
  {
    name: "Sèche-linge à évacuation",
    slug: "seche-linge-a-evacuation",
    catalogUi: {
      title: "Sèche-linge à évacuation reconditionné et durable",
    },
  },
  {
    name: "Lave-vaisselle encastrable",
    slug: "lave-vaisselle-encastrable",
    catalogUi: {
      title: "Lave-vaisselle encastrable reconditionné et durable",
    },
  },
  {
    name: "Lave-vaisselle intégrable",
    slug: "lave-vaisselle-integrable",
    catalogUi: {
      title: "Lave-vaisselle intégrable reconditionné et durable",
    },
  },
  {
    name: "Lave-vaisselle pose libre",
    slug: "lave-vaisselle-pose-libre",
    catalogUi: {
      title: "Lave-vaisselle pose libre reconditionné et durable",
    },
  },
  {
    name: "Mini lave-vaisselle",
    slug: "lave-vaisselle-compact",
    catalogUi: {
      title: "Mini lave-vaisselle reconditionné et durable",
    },
  },
  {
    name: "Lave-vaisselle 45cm",
    slug: "lave-vaisselle-45cm",
    catalogUi: {
      title: "Lave-vaisselle 45cm reconditionné et durable",
    },
  },
  {
    name: "Four & cuisinière encastrable",
    slug: "four-cuisiniere-encastrable",
    catalogUi: {
      title: "Four & cuisinière encastrable reconditionné et durable",
    },
  },
  {
    name: "Cuisinière électrique",
    slug: "cuisiniere-electrique",
    catalogUi: {
      title: "Cuisinière électrique reconditionné et durable",
    },
  },
  {
    name: "Cuisinière à gaz",
    slug: "cuisiniere-a-gaz",
    catalogUi: {
      title: "Cuisinière à gaz reconditionné et durable",
    },
  },
  {
    name: "Mini-four",
    slug: "mini-four",
    catalogUi: {
      title: "Mini-four reconditionné et durable",
    },
  },
  {
    name: "Four pyrolyse",
    slug: "four-pyrolyse",
    catalogUi: {
      title: "Four pyrolyse reconditionné et durable",
    },
  },
  {
    name: "Four multifonction",
    slug: "four-multifonction",
    catalogUi: {
      title: "Four multifonction reconditionné et durable",
    },
  },
  {
    name: "Four vapeur",
    slug: "four-vapeur",
    catalogUi: {
      title: "Four vapeur reconditionné et durable",
    },
  },
  {
    name: "Four à chaleur tournante",
    slug: "four-a-chaleur-tournante",
    catalogUi: {
      title: "Four à chaleur tournante reconditionné et durable",
    },
  },
  {
    name: "Four micro-ondes encastrable",
    slug: "four-micro-ondes-encastrable",
    catalogUi: {
      title: "Four micro-ondes encastrable reconditionné et durable",
    },
  },
  {
    name: "Four micro-ondes pose libre",
    slug: "four-micro-ondes-pose-libre",
    catalogUi: {
      title: "Four micro-ondes pose libre reconditionné et durable",
    },
  },
  {
    name: "Réfrigérateur encastrable",
    slug: "refrigerateur-encastrable",
    catalogUi: {
      title: "Réfrigérateur encastrable reconditionné et durable",
    },
  },
  {
    name: "Réfrigérateur américain",
    slug: "refrigerateur-americain",
    catalogUi: {
      title: "Réfrigérateur américain reconditionné et durable",
    },
  },
  {
    name: "Réfrigérateur congélateur",
    slug: "refrigerateur-congelateur",
    catalogUi: {
      title: "Réfrigérateur congélateur reconditionné et durable",
    },
  },
  {
    name: "Réfrigérateur 1 porte",
    slug: "refrigerateur-1-porte",
    catalogUi: {
      title: "Réfrigérateur 1 porte reconditionné et durable",
    },
  },
  {
    name: "Réfrigérateur multi-portes",
    slug: "refrigerateur-multi-portes",
    catalogUi: {
      title: "Réfrigérateur multi-portes reconditionné et durable",
    },
  },
  {
    name: "Petit réfrigérateur",
    slug: "petit-refrigerateur",
    catalogUi: {
      title: "Petit réfrigérateur reconditionné et durable",
    },
  },
  {
    name: "Plaque à induction",
    slug: "plaque-a-induction",
    catalogUi: {
      title: "Plaque à induction reconditionnée",
    },
  },
  {
    name: "Plaque vitro-céramique",
    slug: "plaque-vitro-ceramique",
    catalogUi: {
      title: "Plaque vitro-céramique reconditionnée",
    },
  },
  {
    name: "Plaque à gaz",
    slug: "plaque-a-gaz",
    catalogUi: {
      title: "Plaque à gaz reconditionnée",
    },
  },
  {
    name: "Congélateur armoire",
    slug: "congelateur-armoire",
    catalogUi: {
      title: "Congélateur armoire reconditionné et durable",
    },
  },
  {
    name: "Congélateur coffre",
    slug: "congelateur-coffre",
    catalogUi: {
      title: "Congélateur coffre reconditionné et durable",
    },
  },
];

export function getProductStaticDataDescription(category) {
  return productTypesStaticData.find((item) => item.slug === category)?.catalogUi?.description;
}

export function getSubCategoryStaticTitle(category1) {
  return SubcategoriesStaticData.find((item) => item.slug === category1)?.catalogUi?.title;
}

export function getCategoryStaticDataTitle(category) {
  return productTypesStaticData.find((item) => item.slug === category)?.catalogUi?.title;
}
